<panel>
	<h1>{{ 'company.syncronize-plans-to-standout-crm.header' | translate }}</h1>
	<section>
		<p>{{ 'company.syncronize-plans-to-standout-crm.description' | translate }}</p>
	</section>
	@if (!loading) {
		<company-products-list #productPlanList [productPlans]="allPlans" [multiSelect]="isSelectable" [sortColumns]="false" [onlyActivePlans]="true" [(selectedProductPlans)]="selectedProductPlans" />
	}
	<section>
		<button ghost (click)="cancel()">{{ 'general.cancel' | translate }}</button>
		<button confirm (click)="submitSelectedPlansToSynchronization();" [active]="selectedProductPlans.length > 0">{{ 'company.syncronize-plans-to-standout-crm.submit-selected-plans-for-synchronization' | translate }}</button>
	</section>
</panel>
